import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const HomeComponent_2 = React.lazy(() => import("../Components/RootComponents/HomeComponent_2"));
const HomePage_2 = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <HomeComponent_2 />
      </Suspense>
    </Fragment>
  );
};

export default HomePage_2;
